import React from 'react';
import AdvancedFilters, { FilterConfig } from '@components/AdvancedFilters';

/**
 * Componente de filtros para a página de relatórios.
 * Usa o componente centralizado AdvancedFilters com configuração específica para relatórios.
 */
export const ReportsFilters: React.FC = () => {
  const filterConfig: FilterConfig = {
    showClientFilter: true,
    showDateRangeFilter: true,
    showCategoryFilter: true,
    showPriorityFilter: true,
    showQrCodeFilter: true,
    showSimilarOnlyFilter: false, // Não mostrar em relatórios
    showAssigneeFilter: true,
    showProviderFilter: true,
    pageType: 'reports',
    variant: 'compact',
  };

  return <AdvancedFilters config={filterConfig} />;
};

export default ReportsFilters;

